import React, { useState } from 'react';
import { get } from '../../services/apiController';
import { toast, ToastContainer } from 'react-toastify';
import { DEBOUNCE_DELAY, monthsDropdown } from '../../util/constant';
import { Table } from 'react-bootstrap';
import Select from 'react-select';
import useDebounce from '../useDebounce';
import FactoryDropdown from './FactoryDropdown';
import { saveAs } from 'file-saver';
import { GrDocumentPdf } from 'react-icons/gr';

const years = Array.from({ length: 4 }, (_, i) => {
  const year = 2024 + i;
  return { value: year, label: year.toString() };
});

const LogSheetReport = () => {
  const [logs, setLogs] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  // const [runningVehicleList, setRunningVehicleList] = useState([]);
  // const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [filters, setFilters] = useState({
    runningVehicleId: '',
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
  });

  const fetchLogEntries = (downloadExcel) => {
    const { runningVehicleId, month, year } = filters;
    if (!month || !year) {
      toast.error('Month and year required.');
      return;
    }
    let url = `/vm/diesel-log-entries/report?runningVehicleId=${runningVehicleId}&month=${month}&year=${year}`;
    if (downloadExcel) url += `&downloadExcel=true`;
    get(url, { responseType: downloadExcel ? 'arraybuffer' : 'json' })
      .then((response) => {
        if (downloadExcel) {
          const { month, year } = filters;
          const fileName = `Vehicle Management Vehicle Expense Report - ${
            monthsDropdown.find((m) => m.value === month)?.label
          } ${year}.pdf`;
          const blob = new Blob([response], { type: 'application/pdf' });
          saveAs(blob, fileName);
        } else {
          setLogs(response?.data);
          setTotalRecords(response?.data?.length);
        }
      })
      .catch((err) => {
        console.log('err', err);
        toast.error(err?.response?.data?.message || err.message);
      });
  };

  // async function getRunningVehicle() {
  //   get(`/vm/running-vehicle`)
  //     .then((response) => {
  //       setRunningVehicleList(response?.data?.rows);
  //     })
  //     .catch((err) => {
  //       toast.error(err.response?.data?.data?.message ?? err.message);
  //     });
  // }

  // useEffect(() => {
  //   getRunningVehicle();
  // }, []);

  useDebounce(
    () => {
      fetchLogEntries();
    },
    [filters],
    DEBOUNCE_DELAY
  );
  return (
    <div>
      <ToastContainer />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Vehicle Expense Report | {totalRecords ?? 0}
          </h4>

          <div className="d-flex align-items-center gap-3">
            <div className="form-floating text-start">
              <Select
                className="input"
                value={monthsDropdown.find((m) => m.value === filters.month)}
                options={monthsDropdown}
                onChange={(selectedOption) => setFilters((prev) => ({ ...prev, month: selectedOption?.value }))}
                placeholder="Select Month"
                isClearable
                isSearchable
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: '55px',
                    minWidth: '200px',
                  }),
                }}
              />
            </div>
            <div className="form-floating text-start">
              <Select
                className="input"
                value={years.find((y) => y.value === filters.year)}
                options={years}
                onChange={(selectedOption) => setFilters((prev) => ({ ...prev, year: selectedOption?.value }))}
                placeholder="Select Year"
                isClearable
                isSearchable
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: '55px',
                    minWidth: '200px',
                  }),
                }}
              />
            </div>
            <FactoryDropdown
              withFloatingLable={true}
              onFactoryChange={() => {
                fetchLogEntries();
                // getRunningVehicle();
              }}
            />
            {/* <div className="form-floating text-start">
              <Select
                className="input"
                value={selectedVehicle}
                options={runningVehicleList.map((item) => ({
                  value: item.id,
                  label: `${item.vehicleName} (${item.modelNumber})`,
                }))}
                onChange={(selectedOption) => {
                  setSelectedVehicle({ value: selectedOption?.value, label: selectedOption?.label });
                  setFilters((prev) => ({ ...prev, runningVehicleId: selectedOption?.value || '' }));
                }}
                placeholder="Select Vehicle"
                isClearable
                isSearchable
                styles={{
                  control: (provided) => ({
                    ...provided,
                    minHeight: '55px',
                    minWidth: '200px',
                  }),
                }}
              />
            </div> */}
            <GrDocumentPdf
              style={{ cursor: 'pointer', width: '2rem', height: '2rem' }}
              onClick={() => fetchLogEntries(true)}
              className="react-icons red"
              title="download pdf"
            />
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <Table responsive striped>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Registration Number</th>
                <th>Starting Kms</th>
                <th>Ending Kms</th>
                <th>Total Kms</th>
                <th>Total Diesel (Ltrs)</th>
                <th>Average Mileage</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              {logs?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item?.registrationNumber || '-'}</td>
                  <td>{item?.startingKms ? Number(item.startingKms).toFixed(2) : '-'}</td>
                  <td>{item?.endingKms ? Number(item.endingKms).toFixed(2) : '-'}</td>
                  <td>{item?.totalKms ? Number(item.totalKms).toFixed(2) : '-'}</td>
                  <td>{item?.totalDieselInLtrs ? Number(item.totalDieselInLtrs).toFixed(2) : '-'}</td>
                  <td>
                    {item?.totalDieselInLtrs && item?.totalKms && Number(item.totalDieselInLtrs) !== 0
                      ? (Number(item.totalKms) / Number(item.totalDieselInLtrs)).toFixed(2)
                      : '-'}
                  </td>
                  <td>₹ {item?.totalAmount ? Number(item.totalAmount).toFixed(2) : '-'}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ backgroundColor: '#f3f6f9', fontWeight: '400' }}>
                <td className="text-center" colSpan="4">
                  Total:
                </td>
                <td>{Number(logs?.reduce((total, item) => total + (item?.totalKms ? Number(item.totalKms) : 0), 0)).toFixed(2)}</td>
                <td>
                  {Number(logs?.reduce((total, item) => total + (item?.totalDieselInLtrs ? Number(item.totalDieselInLtrs) : 0), 0)).toFixed(
                    2
                  )}
                </td>
                <td></td>
                <td>₹ {Number(logs?.reduce((total, item) => total + (item?.totalAmount ? Number(item.totalAmount) : 0), 0)).toFixed(2)}</td>
              </tr>
            </tfoot>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default LogSheetReport;
